import { OrderShowtimeSeatSwapUnavailableReason } from '@vista-digital/ocapi-types/v1';
export const mapOrderShowtimeSelectionsToOrderShowtime = (selections) => (Object.assign(Object.assign({}, selections), { seatSwapStatus: {
        isAvailable: false,
        unavailableReason: OrderShowtimeSeatSwapUnavailableReason.OrderNotCompleted
    } }));
